import { useEffect } from 'react';
import { useSelector, useStore } from 'react-redux';
import { selectIsSessionValidated } from 'services/session/session.selectors';
import { requestUserBalanceIfNecessary } from './user.action';

/**
 * Triggers at every url change if the user is logged and is deemed necessary,
 * an update to the user balance.
 */
export function useUpdateUserBalance() {
  const reduxStore = useStore();
  const isUserLoggedIn = useSelector(selectIsSessionValidated);

  useEffect(() => {
    if (!isUserLoggedIn) {
      return;
    }

    reduxStore.dispatch<any>(requestUserBalanceIfNecessary());
  }, [isUserLoggedIn, reduxStore]);
}
